export enum COMMON_CODE_CATEGORY {
  ADMIN_STATUS = 'ADMIN_STATUS',
  BRAND_CONSULT = 'BRAND_CONSULT',
  IP_STATUS = 'IP_STATUS',
  ADMIN_ROLES = 'ADMIN_ROLES',
  FNB_OWNER = 'FNB_OWNER',
  AGE_GROUP = 'AGE_GROUP',
  EXP_GROUP = 'EXP_GROUP',
  SKILL_GROUP = 'SKILL_GROUP',
  HOW_SKILL = 'HOW_SKILL',
  HOW_OPERATE = 'HOW_OPERATE',
  KB_MEDIUM_CATEGORY = 'KB_MEDIUM_CATEGORY',
  REVENUE_RANGE = 'REVENUE_RANGE',
  CUSTOMER_PAIN_POINT = 'CUSTOMER_PAIN_POINT',
  OPERATION_TIME = 'OPERATION_TIME',
  TENTATIVE_OPEN_OPTION = 'TENTATIVE_OPEN_OPTION',
  DELIVERY_OR_RESTAURANT = 'DELIVERY_OR_RESTAURANT',
}

export const CONST_COMMON_CODE_CATEGORY = Object.values(COMMON_CODE_CATEGORY);
